<template>
  <b-container>
    <vue-headful :title="this.setPageTitle('profilesEditor')" />
    <b-row class="mt-3">
      <b-col cols="5">Profilo punteggio</b-col>
      <b-col cols="7">
        <b-input-group>
          <template v-slot:prepend>
            <b-dropdown id="dropdown-buttons" variant="primary">
              <b-dropdown-item-button @click="saveProfile()" :disabled="selectedProfile.length === 0">{{
                action
              }}</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button
                v-for="(profile, index) in profiles"
                :key="index"
                @click="changeProfile(profile)"
                >{{ profile.text }}</b-dropdown-item-button
              >
            </b-dropdown>
          </template>
          <b-form-input v-model="selectedProfile"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="5">Prodotto test</b-col>
      <b-col cols="7">
        <model-select :options="products" v-model="selectedProduct"> </model-select>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="5"></b-col>
      <b-col cols="7"></b-col>
    </b-row>
    <b-row class="mt-3">
      <b-table striped hover :items="results" :fields="fields"> </b-table>
    </b-row>
  </b-container>
</template>

<script>
import { ModelSelect } from 'vue-search-select'

export default {
  data() {
    return {
      selectedProfile: '',
      selectedProduct: {},
      profiles: [
        { value: 1, text: 'Profilo 1' },
        { value: 2, text: 'Profilo 2' },
        { value: 3, text: 'Profilo 3' },
        { value: 4, text: 'Profilo 4' },
        { value: 5, text: 'Profilo 5' },
        { value: 6, text: 'Profilo 6' },
      ],
      products: [
        { value: 1, text: 'Prodotto 1' },
        { value: 2, text: 'Prodotto 2' },
        { value: 3, text: 'Prodotto 3' },
        { value: 4, text: 'Prodotto 4' },
        { value: 5, text: 'Prodotto 5' },
        { value: 6, text: 'Prodotto 6' },
      ],
    }
  },
  methods: {
    changeProfile(profile) {
      this.selectedProfile = profile.text
    },
  },
  computed: {
    action: function () {
      return this.profiles.some((x) => x.text === this.selectedProfile) ? 'Aggiorna' : 'Salva'
    },
    results: function () {
      return [
        {
          label: 'SRI',
          sampleValue: 1,
          domain: '1-7',
          weight: null,
        },
        {
          label: 'MRM',
          sampleValue: null,
          domain: null,
          weight: null,
        },
        {
          label: 'CRM',
          sampleValue: null,
          domain: null,
          weight: null,
        },
        {
          label: 'Treynor Ratio',
          sampleValue: null,
          domain: null,
          weight: null,
        },
        {
          label: 'Sharpe Ratio on risk free',
          sampleValue: null,
          domain: null,
          weight: null,
        },
        {
          label: 'Gain-Loss ratio on inflation*',
          sampleValue: null,
          domain: null,
          weight: null,
        },
        {
          label: 'Information Ratio',
          sampleValue: null,
          domain: null,
          weight: null,
        },
        {
          label: 'Modigliani Ratio',
          sampleValue: null,
          domain: null,
          weight: null,
        },
      ]
    },
    fields: function () {
      return [
        {
          key: 'label',
          // label: this.$t('search.resultTable.issuer'),
          label: 'Indicatore',
        },
        {
          key: 'sampleValue',
          // label: this.$t('search.resultTable.issuer'),
          label: 'Valore Sample',
        },
        {
          key: 'domain',
          // label: this.$t('search.resultTable.issuer'),
          label: 'Dominio',
        },
        {
          key: 'weight',
          // label: this.$t('search.resultTable.issuer'),
          label: 'Peso',
        },
      ]
    },
  },
  components: {
    ModelSelect,
  },
}
</script>

<style></style>
